module.exports = __webpack_public_path__ + "static/media/ekta_chopra.684fe72b.png";